import React, { Component, Fragment } from "react";
import { HotTable } from "@handsontable/react";
import Handsontable from "handsontable";
import { Redirect } from 'react-router-dom';
import {
  Button,
  Grid,
  GridColumn,
  Dimmer,
  Loader
} from "semantic-ui-react";
import { PropTypes } from "prop-types";
import moment from "moment";
import ModalPopup from "./ModalPopup";
//import AddCategoryForm from "./AddCategoryForm";
import ManageCategoriesHeader from "./ManageCategoriesHeader";
import WarningMessage from "./../../Common/Layout/WarningMessage";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchAllCategories } from "./../../actions/categories/fetchAllCategories";
import { resetAllCategories } from "./../../actions/categories/resetAllCategories";
import { showModal } from "./../../actions/categories/showModal";
import { showLoader } from "./../../actions/categories/showLoader";
import { isEdited } from "./../../actions/categories/isEdited";
import { saveEdits } from "./../../actions/categories/saveEdits";
import { colWidths } from "./../../Constants/categories/colWidths";
import * as cellValidator from "../../Common/Utility/categoryCellValidations";
import { createNotification, NOTIFICATION_TYPE_SUCCESS, NOTIFICATION_TYPE_WARNING } from 'react-redux-notify';

var userDetails = atob(localStorage.getItem("userDetails"));
// if (!userDetails) {
//   return (
//     <Redirect to={{
//       pathname: '/notauth',
//       state: { from: this.props.location }
//     }}
//     />
//   );
// }
if (userDetails) {
    try {

        userDetails = JSON.parse(userDetails);
    }
    catch (e) {
 console.error('Invalid JSON input:', e.message);
    }

}
//console.log("userDetails", userDetails);
var loggedInUserName = userDetails
  ? getFullName(userDetails.UserContext)
  : "ZZ- XCM Web,Administrator";
//let userDetails;
var loggedInUserId = userDetails ? userDetails.UserContext.userId : 16194;
const FIRM_ID = userDetails ? userDetails.UserContext.firmId : 697;

function getFullName(UserContext) {
  var firstName = UserContext.firstName;
  var lastName = UserContext.lastName;
  var middleName = UserContext.middleName;
  var gen = UserContext.generationType;
  var fullName = lastName + ", " + firstName;
  fullName += middleName ? " " + middleName + "." : "";
  fullName += gen ? " " + gen + "." : "";
  return fullName;
}

class CategoriesTable extends Component {
  constructor(props) {
    super(props);
    this.hotTableComponent = React.createRef();
    this.rowMoveData = [];

    // console.log(
    //   "%c Constructor - CategoriesTable.js",
    //   "background: #222; color: #bada55"
    // );

    this.warnNotification = {
      type: NOTIFICATION_TYPE_WARNING,
      duration: 5000,
      canDismiss: true,
    }

    this.succNotification = {
      type: NOTIFICATION_TYPE_SUCCESS,
      duration: 5000,
      canDismiss: true,
    }

    this.dummyState = {
      editedRows: []
    };

    this.state = {
      CATAGORY_LIMIT: 20,
      mychangedRows: [],
      validationError: {
        column: "",
        isValid: true,
        value: "",
        message: ""
      }
    };

    this.settings = {
      licenseKey: "0b014-a057a-62a00-d4631-40c07",
      rowHeaders: true,
      manualRowMove: true,
      manualColumnResize: true,
      colHeaders: [
        "Order",
        "Category Id",
        "Category",
        "Code",
        "Tag Type",
        "Extension Section",
        "Updated On",
        "Updated By",
        "Active"
      ],
      hiddenColumns: {
        columns: [1, 5],
        indicators: false
      },
      columnSorting: {
        indicator: false,
        headerAction: false,
        initialConfig: {
          column: 0,
          sortOrder: "asc"
        }
      },
      fillHandle: false,
      data: props.categories
    };
  }

  static getDerivedStateFromProps(props, state) {
    // console.log(
    //   "%c static getDerivedStateFromProps - CategoriesTable.js",
    //   "background: #222; color: #bada55",
    //   props,
    //   state
    // );

    // if(props.edited == true){
    //   props.isEdited(true)
    // }else{

    // state.mychangedRows = [];
    //}

    return state;
  }

  componentDidMount() {
    // console.log(
    //   "%c componentDidMount - categoriesTable.js",
    //   "background: #222; color: #bada55"
    // );

    if (!userDetails) {
      return;
    }

    if (this.props.categories.length > 0) {
      return;
    }
    this.props.fetchAllCategories(FIRM_ID)
      .then((res) => {
        let cat_order = 1;
        let updateCatOrder = false;
        if (res.payload.categoryData.every((el) => el.cat_Order == 0)) {
          updateCatOrder = true;
        }
        if (updateCatOrder) {
          const todayDate = moment().format("MM/DD/YY");
          //console.log("LOGGED ", loggedInUserId)
          let updatedCategories = res.payload.categoryData.map((item) => {
            if (updateCatOrder) {
              item.cat_Order = cat_order++;
              item.updated_on = todayDate;
              item.updated_by = loggedInUserId;
            }
            return item;
          });
          this.props.saveEdits(updatedCategories, res.payload.categoryData)
        }
      });

    this.setMoveIcon();
    //this.props.showModal(false)

    //   this.settings = {
    //     ...this.settings,
    //     columnSorting: false
    //  }

    // Empty validator
    const emptyValidator = (value, callback) => {
      if (!value || 0 === value.length || value.length > 30) {
        //console.log("false");
        callback(false);
      } else {
        //console.log("true");
        callback(true);
      }
    };

    // code length validation
    const codeValidator = (value, callback) => {
      if (value.length <= 10) {
        callback(true);
      } else {
        callback(false);
      }
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    // console.log(
    //   "%c shouldComponentUpdate - CategoriesTable.js",
    //   "background: #222; color: #bada55",
    //   nextProps,
    //   nextState,
    //   this.props
    // );
    // console.log(nextProps.edited, this.props.edited);
    // && nextProps.edited == this.props.edited

    // if(nextProps.edited == true){
    //   this.props.isEdited(true);
    //   return true
    // }

    // if(nextProps.shouldShowModal.state !== this.props.shouldShowModal.state){
    //   return false;
    // }

    // if(nextProps.notification.msg !== ""){
    //   return false;
    // }

    return true;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // console.log(
    //   "%c componentDidUpdate - CategoriesTable.js",
    //   "background: #222; color: #bada55",
    //   prevProps,
    //   prevState,
    //   snapshot
    // );
  }

  componentWillUnmount() {
    // console.log(
    //   "%c componentWillUnmount - CategoriesTable.js",
    //   "background: #222; color: #bada55"
    // );
  }

  getSnapshotBeforeUpdate(prevProps, prevState) {
    // console.log(
    //   "%c getSnapshotBeforeUpdate - CategoriesTable.js",
    //   "background: #222; color: #bada55",
    //   "prevProps",
    //   prevProps,
    //   "prevState",
    //   prevState
    // );
    return null;
  }

  onClick = () => {
    //console.log("ON CLICK ADD");
    // dispatch show modal action here
    this.props.showModal({
      state: true,
      modalName: "Add Category",
      component: "ADD_CATEGORY_FORM",
      size: "small",
      submitBtn: "Submit",
      denyBtn: "Cancel",
    });
  };

  onClose = () => {
    // dispatch show modal acction here
    this.props.showModal({
      state: false,
      modalName: this.props.showModal.modalName,
      component: this.props.modalContentComponent,
      size: "small",
      submitBtn: this.props.modalSubmitBtn,
      denyBtn: this.props.modalDenyBtn
    });
  };

  onReset = () => {
    //console.log("reset trigerreed", this.props);
    this.state.mychangedRows = [];
    this.props.resetAllCategories();

    const hotInstance = this.hotTableComponent.current.hotInstance;

    hotInstance.updateSettings(this.settings)
    hotInstance.loadData(this.props.categories)
    hotInstance.render();
  };

  save = () => {

    // console.log(
    //   "%c SAVE - categoriesTable.js",
    //   "background: yellow; color: black",
    //   this.state.mychangedRows,
    //   this.rowMoveData,
    //   this.dummyState.editedRows,
    //   // this.props.categories
    // );

    const hotInstance = this.hotTableComponent.current.hotInstance;
    const changedRows = [...new Set(this.dummyState.editedRows)];

    //console.log("Changed Rows", changedRows)

    const cat = hotInstance
      .getData()
      .map(
        ([
          cat_Order,
          category_id,
          name,
          code,
          type,
          extension_section,
          updated_on,
          updated_by,
          is_active
        ]) => ({
          cat_Order,
          category_id,
          name,
          code,
          type,
          extension_section,
          updated_on,
          updated_by,
          is_active
        })
      );

    // console.log("get data at row", hotInstance.getData(), cat)

    const changedCategories = cat
      .map((elem, i) => {
        elem.cat_Order = i + 1;
        elem.updated_by = changedRows.includes(elem.category_id) ? loggedInUserId : this.props.categories.filter(el => el.category_id === elem.category_id)[0].updated_by;
        elem.updated_byName = changedRows.includes(elem.category_id) ? loggedInUserName : this.props.categories.filter(el => el.category_id === elem.category_id)[0].updated_byName;
        elem.firm_id = FIRM_ID;
        let elemInCategories = this.props.categories.filter(item => item.category_id == elem.category_id)[0];
        elem.is_custom = elemInCategories.is_custom;
        elem.hasLinkedDueDates = elemInCategories.hasLinkedDueDates;
        return elem;
      })
      .filter(elem => changedRows.includes(elem.category_id));

    //const updatedCat = Object.assign([], this.props.categories, changedCategories)
    // const updatedCat = this.props.categories.map((elem, i) => {
    //   return Object.assign(elem, changedCategories[i]);
    // });

    this.props.saveEdits(changedCategories, this.props.categories)
    //this.props.saveEdits(this.props.categories, this.props.categories)
    //console.log("CHANGES : ", changedCategories , this.props.categories , hotInstance.getData())

    //this.props.saveEdits(changedCategories, this.props.categories);
    this.dummyState.editedRows = [];
    this.state.mychangedRows = [];

    const successNotification = {
      message: `Saved Successfully`,
      ...this.succNotification
    }
    this.props.createNotification(successNotification);

    hotInstance.updateSettings(this.settings)
    hotInstance.loadData(this.props.categories)
    hotInstance.render();

    //this.props.showLoader(true)
    // the below line resolves row move issue after save
    //hotInstance.updateSettings(this.settings);
    //this.props.showLoader(false)

    //console.log("after save : ", this)
  };

  afterGetColHeaderHandler(col, TH) {
    //console.log("afterGetColHeaderHandler", this);
    var editableFields = [2, 3, 4, 8];
    if (editableFields.includes(col)) {
      TH.classList.add("editable");
    }

    return;
  }

  setMoveIcon = () => {
    let rowHeaders = document.getElementsByClassName("rowHeader");
    for (var i = 0; i < rowHeaders.length; i++) {
      rowHeaders[i].innerText = ""; // Change the content
    }
  };

  handleHOTChangeBefore = (changes, sources) => {
    //console.log("BEFORE CHANGES : ", changes, sources)
    if (sources !== "edit") {
      return;
    }

    // if there is no change then there is no need to validate
    if (changes[0][2] === changes[0][3]) {
      return;
    }

    switch (changes[0][1]) {

      case 'is_active':
        const countOfIsActive = this.props.categories.filter(
          elem => elem.is_active === true
        ).length;
        if (countOfIsActive == 1 && changes[0][3] == false) {
          changes[0][3] = changes[0][2];

          const warningNotification = {
            message: `There should be atleast one active category`,
            ...this.warnNotification
          }
          this.props.createNotification(warningNotification);
          return;
        }

        if (changes[0][3] == false) {
          this.props.showModal({
            state: true,
            modalName: "Are you sure?",
            component: "TASK_COUNT",
            size: "small",
            submitBtn: "Yes",
            denyBtn: "No",
            payload: {
              data: changes
            }
          });
          changes[0][3] = changes[0][2];
        }
        break;

      case 'name':
      case 'code':
        this.updateCats(changes, changes[0][1]);
        break;
      case 'type':
        const hot = this.hotTableComponent.current.hotInstance;
        const changedCategoryId = hot.getDataAtRow(changes[0][0])[1];
        if (changes[0][3]) {
          const category = this.props.categories.filter((elem) => {
            return elem.category_id === changedCategoryId
          })[0]

          if(category.hasLinkedDueDates || category.category_id == 1){
            const warningNotification = {
              message: `The Tag Type cannot be changed as there are Linked Due Dates associated to the ${category.name} Category`,
              ...this.warnNotification,
              position: "BottomRight"
            }
            this.props.createNotification(warningNotification)
            changes[0][3] = changes[0][2];
          }
        }
        
        this.updateType(changes, changes[0][1]);
        break;
    }

  };

  updateCats(changes, type) {
    //console.log("updateCats --------------------------", changes, type);
    const cats = this.props.categories.map(elem => (elem[type]).toUpperCase());
    let cellValue = changes[0][2];
    if (cellValue) {
      cats.splice(cats.indexOf(cellValue.toUpperCase()), 1);
    }
    if (cats.includes(changes[0][3].toUpperCase())) {
      changes[0][3] = changes[0][2];

      const warningNotification = {
        message: `A Category already exists with that ${type == "name" ? "name" : "code"}. Please try again`,
        ...this.warnNotification,
        position: "BottomRight"
      }
      this.props.createNotification(warningNotification);
    }

    // empty validation - replaces to old value incase empty
    if (changes[0][3] == "") {
      changes[0][3] = changes[0][2]

      const warningNotification = {
        message: `${changes[0][1] === "name" ? "Category" : "Code"} should not be empty`,
        ...this.warnNotification
      }

      this.props.createNotification(warningNotification);
    }

    // validation for name 100 characters limit 
    if (type === "name" && changes[0][3].length > 100) {
      changes[0][3] = changes[0][2]

      const warningNotification = {
        message: `Category should not contain more than 100 characters`,
        ...this.warnNotification
      }

      this.props.createNotification(warningNotification);
    }

    // length & special characters validation - replaces to old value incase invalid entry
    if (type === "name" ? !(/^([a-zA-Z0-9_/\-]+( [a-zA-Z0-9_/\-]+)*)$/.test(changes[0][3])) : !(/^([a-zA-Z0-9_-]){1,10}$/.test(changes[0][3]))) {
      
      var warningMessage = "";
      if (type === "name") {     
        if (changes[0][3].length > 100) {
          warningMessage = "should not contain more than 100 characters"
        } else {
          warningMessage = "should not contain special characters"
        }

      }

      if (type === "code") {
        if (changes[0][3].length > 10) {
          warningMessage = "should not contain more than 10 characters"
        } else {
          warningMessage = "should not contain special characters"
        }
      }

      changes[0][3] = changes[0][2]

      const warningNotification = {
        message: `${changes[0][1] === "name" ? `Category ${warningMessage}` : `Code ${warningMessage}`}`,
        ...this.warnNotification
      }

      this.props.createNotification(warningNotification);
    }
  }

  updateType(changes) {
    const types = this.props.categoryTypes;
    if (changes[0][3] == "" || !types.includes(changes[0][3])) {
      changes[0][3] = changes[0][2]
    }
  }

  handleHOTChange = (changes, sources) => {
    if (sources == "edit") {
      const hot = this.hotTableComponent.current.hotInstance;
      const todayDate = moment().format("MM/DD/YY");
      const changedCategoryId = hot.getDataAtRow(changes[0][0])[1];

      if (!this.dummyState.editedRows.includes(changedCategoryId)) {
        this.dummyState.editedRows.push(changedCategoryId);
      }

      changes.map(element => {
        let changedColIndex = hot.propToCol(element[1]);
        let changedRowIndex = element[0];

        //hot.setCellMeta(changes[0][0], 6, "className", "editedCellColor");
        //hot.setCellMeta(changes[0][0], 7, "className", "editedCellColor");

        if (element[2] !== element[3]) {
          if (this.props.edited != true) {
            this.props.isEdited(true);
          }
          hot.setCellMeta(changedRowIndex, 6, "className", "editedCellColor");
          hot.setCellMeta(changedRowIndex, 7, "className", "editedCellColor");
          hot.setCellMeta(
            changedRowIndex,
            changedColIndex,
            "className",
            "editedCellColor"
          );

          hot.setDataAtCell(changedRowIndex, 6, todayDate, 'ignore');
          hot.setDataAtCell(changedRowIndex, 7, loggedInUserName, 'ignore');
          //console.log("changing data-------------------------------------", changes);
          this.callback([
            {
              col: changedColIndex,
              row: changedRowIndex
            },
            {
              col: 6,
              row: changedRowIndex
            },
            {
              col: 7,
              row: changedRowIndex
            }
          ]);
        }
        // console.log("%c changes ", "background: blue; color: white", changedRowIndex , changedColIndex, this.state.mychangedRows)
      });
    }
  };

  hotBeforeRowMove = (rows, target) => {
    //if(this.props.edited != true){
    this.props.isEdited(true);
    //}

    this.setMoveIcon();
  };

  updateMyChangedRows(rows, target) {
    //console.log('checking rows = ', rows, 'target = ', target)
    let dataLength = this.hotTableComponent.current.hotInstance.getData().length + 1;
    let originalRows = [...Array(dataLength).keys()];
    let reoderedRows = [];
    let direction = 'down';
    let start = 0;
    let stop = dataLength;

    if (rows.some((el) => el > target)) {
      direction = 'up';
    }
    if (direction === 'up') {
      for (let i = 0; i < dataLength; i++) {
        if (i === target) {
          reoderedRows.splice(i, 0, ...rows, i);
        } else {
          if (!reoderedRows.includes(i)) {
            reoderedRows.push(i);
          }
        }
      }
    } else {
      for (let i = dataLength - 1; i >= 0; i--) {
        if (i === target) {
          reoderedRows.splice(i, 0, i, ...rows.reverse());
        } else {
          if (!reoderedRows.includes(i)) {
            reoderedRows.push(i);
          }
        }
      }
      reoderedRows.reverse();
    }
    this.state.mychangedRows.forEach((cellObj) => {
      if (originalRows.includes(cellObj.row)) {
        cellObj.row = reoderedRows.indexOf(cellObj.row);
      }
    });
  }

  hotAfterRowMove = (rows, target) => {
    const hot = this.hotTableComponent.current.hotInstance;

    let colOrder = hot.getDataAtProp(0);
    let origCatOrder = this.props.categories.map(elem => elem.cat_Order);

    this.updateMyChangedRows(rows, target);

    // columns to be set editedColor
    let setEditedClassesTo = [0, 6, 7];
    let callbackArr = [];
    colOrder.forEach((elem, index) => {
      if (elem !== origCatOrder[index]) {
        this.rowMoveData.push(hot.getSourceDataAtRow(index));
        setEditedClassesTo.map(item => {
          //hot.setCellMeta(index, item, "className", "editedCellColor")
          if (!this.checkRowExists(index, item)) {
            callbackArr.push({ col: item, row: index })
          }
        });
      }
    });
    this.callback(callbackArr);

    //console.log("%c changes ", "background: orange; color: black", this.state.mychangedRows, rows, target)

    // This solves the single row color residing issue on the moved row cell
    /*
    this.state.mychangedRows.forEach(elem => {
      if (elem.row == rows[0]) {
        elem.row = target - 1 < 0 ? 0 : target - 1; // THIS NEEDS TO BE CHANGED 
      }
    })
    */

  };
  checkRowExists(row, col) {
    return this.state.mychangedRows.some((obj) => obj.row == row && obj.col == col);
  }

  tooltipRenderer(instance, td, row, col, prop, value, cellProperties) {
    Handsontable.renderers.TextRenderer.apply(this, arguments);
    td.innerHTML =
      '<div title="' + td.innerHTML + '">' + td.innerHTML + "</div>";
  }

  afterGetRowHeaderHandler(col, TH) {
    TH.className = "colHeaderCustom";
    TH.innerText = "=";
  }

  showLoader(bool) {
    if (bool) {
      return (
        <Dimmer active inverted>
          <Loader inverted>Loading</Loader>
        </Dimmer>
      );
    }
  }

  afterGridRender() {

  }

  beforeGridRender() {
    if (this.hotTableComponent.current != null) {
      const hot = this.hotTableComponent.current.hotInstance;
      const hotInstance = this.hotTableComponent.current.hotInstance;

      //console.log("hot instanec" , hotInstance)

      // This should happen based on a flag after resize
      // function windowResize(){
      //   var body = document.getElementsByTagName('body');
      //   console.log("trigerred aftergrid render")
      //   if(window.innerWidth < 1200){
      //     console.log("after resize : ", body)
      //     const settings = { ...this.settings, width: window.innerWidth };
      //     hotInstance.updateSettings(settings)
      //     body[0].style.overflowX = "scroll";
      //   }else{
      //     const settings = { ...this.settings, width: window.innerWidth };
      //     hotInstance.updateSettings(settings)
      //     body[0].style.overflowX = "hidden";
      //   }
      // }

      // window.addEventListener('resize', windowResize);

      //console.log("after renderer ----------------------------------------------");
      if (this.rowMoveData.length) {
        //console.log(this.rowMoveData);
        //hot.setDataAtRowProp(this.rowMoveData);
        const todayDate = moment().format("MM/DD/YY");
        //hot.setDataAtCell(index, 7, loggedInUserName);
        this.rowMoveData.forEach((item) => {
          this.props.categories.map((category) => {
            if (category.category_id == item.category_id) {
              category.updated_on = todayDate;
              category.updated_byName = loggedInUserName;
              this.dummyState.editedRows.push(category.category_id);
            }
          })
        })
        this.rowMoveData = [];
        /*
        this.rowMoveData.forEach((data) => hot.setDataAtCell(data.row, data.col,)
        */

      }
      //nnconsole.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@',this.state.mychangedRows);
      this.state.mychangedRows.forEach(element => {
        //setTimeout(() => {
        //console.log("mychangedRows", element)
        hot.setCellMeta(
          element.row,
          element.col,
          "className",
          "editedCellColor"
        );

        //},Math.floor(Math.random() * (5000 - 1000) + 1000));
      });
      //console.log(
      //  "%c AFTER GRID RENDER",
      //  "background: #fff; color: blue",
      //  this.state.mychangedRows
      //);
    }
  }

  validateCells(isValid, value, row, prop, source) {
    /*
    if(!isValid){
      this.setState({
          validationError:{
          isValid,
          value,
          column: prop,
          message: `${prop === "name" ? "Category" : prop} : ${value.length ? "Should not contain special characters" : "should not be empty"}`
        }
      })
    }else{
      this.setState({
        validationError:{
        isValid,
        value,
        column: prop,
        message: ""
      }
    })
    }
    */
    //console.log(isValid, value, row, prop , source);
  }

  callback(data) {
    if (!data) {
      return;
    }
    //console.log("before checking data and mychangedRows", JSON.stringify(this.state.mychangedRows), JSON.stringify(data));
    if (data && typeof data === "object") {
      this.state.mychangedRows.push(...data);
    }
    //console.log("after checking data and mychangedRows", JSON.stringify(this.state.mychangedRows), JSON.stringify(data));
  }
  showAddCategoryBtn() {
    /*
    let emailId = userDetails ? userDetails.UserContext.emailId : "";
    //let allowedEmails = ["117web@xcmsolutions.com", "technicalsales@xcmsolutions.com"];
    let allowedEmails = [];
    if (allowedEmails.indexOf(emailId) < 0) {
      return;
    }
    */
    return (
      <Button
        disabled={this.props.categories.length >= this.state.CATAGORY_LIMIT ? true : false}
        primary
        style={{
          marginRight: "1%",
          float: "right",
          display: "block"
        }}
        title="Add Category"
        onClick={this.onClick}
      >
        {this.props.categories.length >= this.state.CATAGORY_LIMIT
          ? "Max Categories Reached"
          : "Add Category"}
      </Button> 
    );
  }

  render() {
    //console.log(
    //  "%c render - CategoriesTable.js",
    //  "background: #222; color: #bada55"
    //);

    const Columns = [
      { data: "cat_Order", type: "text", readOnly: true },
      { data: "category_id", type: "text", readOnly: true },
      {
        data: "name",
        type: "text",
        skipColumnOnPaste: true,
        allowEmpty: false,
        allowInvalid: false,
        invalidCellClassName: "htInvalid",
        validator: cellValidator.nameValidator,
        renderer: this.tooltipRenderer
      },
      {
        data: "code",
        type: "text",
        renderer: this.tooltipRenderer,
        skipColumnOnPaste: true,
        allowEmpty: false,
        allowInvalid: false,
        invalidCellClassName: "htInvalid",
        validator: cellValidator.codeValidator,
        // validator: function (value, callback) {
        //   if (value.length > 15) {
        //     alert(
        //       "Max character limit for code is 15. Extra characters will be removed"
        //     );
        //     this.instance.setDataAtCell(
        //       this.row,
        //       this.col,
        //       value.substring(0, 10),
        //       null
        //     );
        //   }
        //   callback(true);
        // }
      },
      {
        data: "type",
        type: "dropdown",
        source: this.props.categoryTypes,
        skipColumnOnPaste: true,
        // allowEmpty: false,
        // allowIndvalid: false,
        validator: cellValidator.typeValidator
      },
      { data: "extension_section", type: "checkbox", readOnly: true },
      {
        data: "updated_on",
        type: "text",
        renderer: this.tooltipRenderer,
        readOnly: true
      },
      {
        data: "updated_byName",
        type: "text",
        readOnly: true,
        renderer: this.tooltipRenderer
      },
      { data: "is_active", type: "checkbox", skipColumnOnPaste: true }
    ];

    const displayMessage = `Please log back in to the application to view the change(s)`;

    if (!userDetails) {
      return (
        <Redirect to={{
          pathname: '/webapp/notauth',
          state: { from: this.props.location }
        }}
        />
      );
    }

    return (
      <Fragment>
        <ModalPopup
          categories={this.props.categories}
          hotInstanceProps={this.hotTableComponent}
          changedRows={this.callback.bind(this)}
          user={{id: loggedInUserId, name: loggedInUserName, firm: FIRM_ID}}
        />

        {this.props.shouldShowLoader ? (
          <Dimmer active inverted>
            <Loader inverted>Loading</Loader>
          </Dimmer>
        ) : (
            <div />
          )}

        <div id="hot-app">
          <Grid
            columns={3}
            padded
            verticalAlign="middle"
            style={{ background: "#fff" }}
          >
            <Grid.Row columns={2}>
              <Grid.Column>
                <ManageCategoriesHeader />
              </Grid.Column>
              <Grid.Column style={{ padding: 0 }}>
                {this.showAddCategoryBtn()}
              </Grid.Column>
            </Grid.Row>
          </Grid>
          {this.props.categories.length >= 1 ? (
            <HotTable
              id="categoriesHot"
              ref={this.hotTableComponent}
              settings={this.settings}
              data={this.props.categories}
              width="100%"
              colWidths={colWidths}
              columns={Columns}
              afterGetColHeader={this.afterGetColHeaderHandler}
              afterGetRowHeader={this.afterGetRowHeaderHandler}
              //afterChange={this.handleHOTChange.bind(this)}
              //afterSelection={this.onSelection}
              afterChange={(changes, source) =>
                this.handleHOTChange(changes, source)
              }
              beforeChange={(changes, source) => {
                this.handleHOTChangeBefore(changes, source);
              }}
              beforeRowMove={(rows, target) =>
                this.hotBeforeRowMove(rows, target)
              }
              afterRowMove={(rows, target) =>
                this.hotAfterRowMove(rows, target)
              }
              /*
              afterValidate={(isValid, value, row, prop , source) => {
                this.validateCells(isValid, value, row, prop , source)
              }}
              */
              // this is for prevention of page error issue when click delete / backspace on a cell
              beforeKeyDown={(event) => {
                if (event.keyCode === 46 || event.keyCode === 8) {
                  event.stopImmediatePropagation()
                  //Handsontable.Dom.stopImmediatePropagation(event);
                }
              }}
              beforeRender={this.beforeGridRender.bind(this)}
              afterRender={this.afterGridRender.bind(this)}
              stretchH="all"
            />
          ) : (
              <Dimmer active inverted>
                <Loader inverted>Loading</Loader>
              </Dimmer>
            )}


          <Grid padded textAlign="right">
            <Grid.Row columns={2}>
              <GridColumn width={10} textAlign="left">

                {this.props.edited || this.props.newCategoryAdded ? (
                  <WarningMessage message={displayMessage} />
                ) : <span />}
              </GridColumn>

              {/* <GridColumn textAlign="left"> */}
              {/* {this.state.validationError.isValid ?  */}
              {/* <span /> : */}
              {/* <Grid padded textAlign="right"> */}
              {/* <Grid.Row columns={1}> */}
              {/* <WarningMessage header={`Validation Errors`} message={`${this.state.validationError.message}`} /> */}
              {/* </Grid.Row> */}
              {/* </Grid> */}
              {/* } */}
              {/* </GridColumn> */}

              {this.props.edited ? (
                <Grid.Column width={6}>
                  <Button default title="Reset" onClick={this.onReset}>
                    Reset
                  </Button>
                  <Button primary onClick={this.save} title="Save Edit">
                    Save
                  </Button>
                </Grid.Column>
              ) : <span />}
            </Grid.Row>
          </Grid>



        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  //console.log("from mapStateToProps", state);
  return {
    categories: state.allCategories.categories,
    categoryTypes: state.allCategories.categoryTypes,
    originalCategories: state.allCategories.originalCategories,
    shouldShowModal: state.allCategories.showModal,
    shouldShowLoader: state.allCategories.showLoader,
    edited: state.allCategories.edited,
    newCategoryAdded: state.allCategories.newCategoryAdded,
    modalSubmitBtn: state.allCategories.showModal.submitBtn,
    modalDenyBtn: state.allCategories.showModal.denyBtn,
    modalContentComponent: state.allCategories.showModal.component,
    createNotification: state.allCategories.createNotification
  };
}

function mapDispatchToProps(dispatch) {
  // console.log(
  //   "from mapDispatchToProps",
  //   fetchAllCategories(),
  //   showModal(),
  //   isEdited()
  // );
  return bindActionCreators(
    {
      fetchAllCategories,
      showModal,
      showLoader,
      resetAllCategories,
      isEdited,
      saveEdits,
      createNotification
    },
    dispatch
  );
}

CategoriesTable.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      cat_Order: PropTypes.number,
      category_id: PropTypes.number,
      code: PropTypes.string,
      extension_section: PropTypes.bool,
      firm_id: PropTypes.number,
      is_active: PropTypes.bool,
      is_custom: PropTypes.bool,
      name: PropTypes.string,
      type: PropTypes.string,
      updated_by: PropTypes.number,
      updated_on: PropTypes.string,
    })
  ),
  originalCategories: PropTypes.string,
  //shouldShowModal: PropTypes.bool,
  edited: PropTypes.bool
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CategoriesTable);
